import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { Medium } from './medium.model';
import { catchError, map, retry } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class MediaService {
  private apiUrl = '/api/media';

  constructor(
    public http: HttpClient,
    public authService: AuthService,
  ) {}

  getMedia(): Observable<Medium[]> {
    return this.http.get<Medium[]>(this.apiUrl)
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  getMediaUsedInTemplate(ids: string[]): Observable<Medium[]> {
    return this.http.post<Medium[]>(`${this.apiUrl}/used`, ids)
      .pipe(
        retry(3),
        map(
          result => result
        ),
        catchError(this.errorHandler)
      );
  }

  getMedium(id: string): Observable<any> {
    return this.http.get(`${this.apiUrl}/${id}`);
  }

  postMedium(medium: Medium): Observable<any> {
    const _id = this.authService.getUserId();
    if (medium.printPieceNumber === '') delete medium.printPieceNumber;
    const mediumAndOwnerId = {
      owner: _id,
      ...medium,
    };
    return this.http.post(this.apiUrl, mediumAndOwnerId);
  }

  updateMedium(id: string, updatedMedium: any): Observable<any> {
    const updateMedium = this.http.patch<Medium>(`${this.apiUrl}/${id}`, updatedMedium);
    return updateMedium;
  }

  deleteMedium(id: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }

  private errorHandler(error: HttpErrorResponse): Observable<never> {
    console.error('Fehler aufgetreten!');
    return throwError(error);
  }
}
